import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventModel } from '../../models/workflow-report/workflow-event.model';
import { WorkflowService } from '../../services/workflow-service';

@Component({
  selector: 'app-workflow-report',
  templateUrl: './workflow-report.component.html',
  styleUrls: ['./workflow-report.component.css']
})
export class WorkflowReportComponent implements OnInit {

  public reportData: EventModel[];
  public selectedEvent: EventModel;

  constructor(public dialogRef: MatDialogRef<WorkflowReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public workflowService: WorkflowService) { }

  ngOnInit(): void {
    this.getReportsData();
  }

  getReportsData() {
    this.reportData = this.data.reportData;
    this.selectedEvent = this.reportData[0];
    this.selectedEvent.triggeredAt = new Date(this.data.reportData[0].triggeredAt);
  }

  /**
   * Loads active event
   * @param eventId
   */
  isActiveEvent(eventId: number) {
    return eventId == this.selectedEvent.eventId;
  }

  /**
   * Loads Event data
   * @param event
   */
  loadEventData(event: EventModel) {
    this.selectedEvent = event;
  }

  /**Closes the modal */
  onCancelClick(): void {
    this.dialogRef.close();
  }

}
